import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

const ACCENT = '#8850BF';
const SURFACE = '#FFFFFF';
const BORDER = 'rgba(0,0,0,0.08)';
const TEXT = '#1B1B1F';
const TEXT_MUTED = '#5F6470';
const SHADOW = '0 18px 40px rgba(0,0,0,0.12)';

export const StyledModal = styled(Modal)`
  .kvx-modal-dialog {
    max-width: 1000px;
  }

  .kvx-modal-content,
  .modal-content {
    border-radius: 16px;
    background: ${SURFACE};
    border: 1px solid ${BORDER};
    box-shadow: ${SHADOW};
    overflow: hidden;
    color: ${TEXT};
  }

  .modal-body {
    padding: 16px 18px 18px;
    background: ${SURFACE};
  }
`;

export const HeaderBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px 8px;
  border-bottom: 1px solid ${BORDER};
  background: ${SURFACE};
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  letter-spacing: 0.2px;
  color: ${ACCENT};
`;

export const ControlsRow = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px 14px;
  align-items: center;
  margin-top: 6px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const SegmentedGroup = styled.div`
  display: inline-flex;
  padding: 4px;
  border-radius: 12px;
  background: #f6f7fb;
  border: 1px solid ${BORDER};
`;

export const SegmentedBtn = styled.button.attrs({ type: 'button' })<{
  $active?: boolean;
}>`
  appearance: none;
  border: none;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 0.875rem;
  color: ${({ $active }) => ($active ? '#0B0B0F' : TEXT)};
  background: ${({ $active }) => ($active ? '#EDE6F6' : 'transparent')};
  box-shadow: ${({ $active }) =>
    $active ? 'inset 0 -1px 0 rgba(0,0,0,0.06)' : 'none'};
  cursor: pointer;
  transition: 0.18s ease;

  &:not(:first-child) {
    margin-left: 6px;
  }

  &:hover {
    background: ${({ $active }) => ($active ? '#EDE6F6' : '#F0F2F7')};
  }

  &:focus {
    outline: 2px solid ${ACCENT};
    outline-offset: 2px;
  }
`;

export const SearchWrap = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  background: #f3f4f7;
  border: 1px solid ${BORDER};
  border-radius: 12px;
  padding: 0 12px 0 36px;
  height: 40px;

  svg {
    position: absolute;
    left: 10px;
    width: 18px;
    height: 18px;
    color: ${TEXT_MUTED};
  }

  .MuiCircularProgress-root {
    position: absolute;
    right: 10px;
  }

  .placeholder-end {
    position: absolute;
    right: 10px;
    width: 16px;
    height: 16px;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  color: ${TEXT};
  font-size: 0.95rem;

  &::placeholder {
    color: ${TEXT_MUTED};
  }
`;

export const StatusAssistive = styled.div`
  font-size: 0.8rem;
  color: ${TEXT_MUTED};
`;

export const GridWrap = styled.div`
  margin-top: 12px;

  .kvx-grid {
    /* Cabeçalho */
    .MuiDataGrid-columnHeaders {
      background: #f7f2fc;
      border-bottom: 1px solid ${BORDER};
      color: ${TEXT};
      min-height: 44px !important;
    }

    .MuiDataGrid-columnHeader {
      font-weight: 600;
    }

    .hideRightSeparator .MuiDataGrid-columnSeparator {
      display: none;
    }

    /* Linhas */
    .MuiDataGrid-row {
      border-bottom: 1px solid rgba(0, 0, 0, 0.04);
      transition: background 0.12s ease;
    }

    .MuiDataGrid-row:hover {
      background: #f6f8fc;
    }

    .kvx-row--selected {
      background: #eaf8ef;
    }

    .MuiDataGrid-columnHeaderTitle {
      color: ${SURFACE};
    }

    .MuiDataGrid-cell {
      color: ${TEXT};
    }

    .MuiDataGrid-footerContainer {
      border-top: 1px solid ${BORDER};
      color: ${TEXT_MUTED};
      min-height: 44px;
      background: ${SURFACE};
    }
  }
`;

export const FooterBar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 14px;
  background: ${SURFACE};
`;
